import React from 'react';
import styled, { ThemeContext } from 'styled-components';
import AppConfig from '../../config/app-config';
import { LowerLogo } from '../../config/customers/lower/components/logo/lower-logo';

// eslint-disable-next-line @typescript-eslint/no-var-requires

function GlobalHeader() {
  const theme = React.useContext(ThemeContext);

  const isLower = AppConfig.themeName.toLowerCase() === 'lower';

  return (
    <Container>
      <a href={'/'}>
        {isLower
          ? <LowerLogo />
          : (
            <BrandLogo
              src={theme.logo.image}
              alt={'Brand Logo'}
            />
          )}
      </a>
    </Container>
  );
}

const Container = styled.div`
  ${({ theme }) => `
    margin-bottom: 24px;
    padding: 24px;
    box-shadow: ${theme.logo.boxShadow};
    margin: ${theme.logo.margin};
    ${theme.media.tablet} {
      padding-left: ${theme.logo.paddingLeft};
    }
  `}  
`;

const BrandLogo = styled.img`
  ${({ theme }) => `
      width: ${theme.logo.width};
    ${theme.media.tablet} {
      width: ${theme.logo.tabletWidth};
    }
  `}
`;

export default GlobalHeader;
